export default __webpack_public_path__ + "static/reel-slice-834221e4c3ba688ec7d6d2459e3a862f.png";